import script from "./PositionDetailView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PositionDetailView.vue?vue&type=script&lang=ts&setup=true"

import "./PositionDetailView.vue?vue&type=style&index=0&id=807dfeb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-807dfeb0"]])

export default __exports__